(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[508],{

/***/ 28:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/membership",
      function () {
        return __webpack_require__(6321);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);




var SEO = function(param) {
    var title = param.title, description = param.description, pageTitle = param.pageTitle, nofollow = param.nofollow, noindex = param.noindex;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
                title: title,
                description: description,
                noindex: noindex,
                nofollow: nofollow
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: pageTitle !== null && pageTitle !== void 0 ? pageTitle : title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__);




var Img = function(param) {
    var src = param.src, alt = param.alt, _lazyLoad = param.lazyLoad, lazyLoad = _lazyLoad === void 0 ? true : _lazyLoad, containerProps = param.containerProps, imgProps = param.imgProps, children = param.children, aspectRatio = param.aspectRatio;
    var normalImagePlaceholder = lazyLoad && typeof (imgProps === null || imgProps === void 0 ? void 0 : imgProps.placeholder) == "string" ? imgProps === null || imgProps === void 0 ? void 0 : imgProps.placeholder : undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, containerProps), {
        children: [
            lazyLoad ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_1__.LazyLoadImage, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                src: src,
                alt: alt
            }, imgProps)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("picture", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                    src: src,
                    alt: alt
                }, imgProps), {
                    placeholder: normalImagePlaceholder,
                    style: {
                        aspectRatio: aspectRatio
                    }
                }))
            }),
            children
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Img);


/***/ }),

/***/ 4046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var BookingIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "14",
        height: "10",
        viewBox: "0 0 14 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.99929 8.75C8.99929 8.86051 8.95539 8.96649 8.87725 9.04463C8.79911 9.12277 8.69313 9.16667 8.58262 9.16667H1.91595C1.80545 9.16667 1.69947 9.12277 1.62133 9.04463C1.54319 8.96649 1.49929 8.86051 1.49929 8.75V1.25C1.49929 1.13949 1.54319 1.03351 1.62133 0.955372C1.69947 0.877232 1.80545 0.833333 1.91595 0.833333H8.58262C8.69313 0.833333 8.79911 0.877232 8.87725 0.955372C8.95539 1.03351 8.99929 1.13949 8.99929 1.25V2.91667C8.99929 3.02717 9.04319 3.13315 9.12133 3.21129C9.19947 3.28943 9.30545 3.33333 9.41595 3.33333C9.52646 3.33333 9.63244 3.28943 9.71058 3.21129C9.78872 3.13315 9.83262 3.02717 9.83262 2.91667V1.25C9.83262 0.918479 9.70092 0.600537 9.46651 0.366117C9.23208 0.131696 8.91414 0 8.58262 0H1.91595C1.58443 0 1.26649 0.131696 1.03207 0.366117C0.797651 0.600537 0.665955 0.918479 0.665955 1.25V8.75C0.665955 9.08152 0.797651 9.39946 1.03207 9.63388C1.26649 9.8683 1.58443 10 1.91595 10H8.58262C8.91414 10 9.23208 9.8683 9.46651 9.63388C9.70092 9.39946 9.83262 9.08152 9.83262 8.75V7.08333C9.83262 6.97283 9.78872 6.86685 9.71058 6.7887C9.63244 6.71057 9.52646 6.66667 9.41595 6.66667C9.30545 6.66667 9.19947 6.71057 9.12133 6.7887C9.04319 6.86685 8.99929 6.97283 8.99929 7.08333V8.75Z",
                fill: "#616161"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.8776 5.295C13.9164 5.2563 13.9472 5.21032 13.9682 5.15969C13.9892 5.10907 14 5.05481 14 5C14 4.94519 13.9892 4.89093 13.9682 4.84031C13.9472 4.78968 13.9164 4.7437 13.8776 4.705L11.3776 2.205C11.2994 2.12676 11.1933 2.08281 11.0826 2.08281C10.972 2.08281 10.8659 2.12676 10.7876 2.205C10.7094 2.28324 10.6654 2.38935 10.6654 2.5C10.6654 2.61065 10.7094 2.71676 10.7876 2.795L12.5768 4.58333H5.24929C5.13878 4.58333 5.0328 4.62723 4.95466 4.70537C4.87652 4.78351 4.83262 4.88949 4.83262 5C4.83262 5.11051 4.87652 5.21649 4.95466 5.29463C5.0328 5.37277 5.13878 5.41667 5.24929 5.41667H12.5768L10.7876 7.205C10.7094 7.28324 10.6654 7.38935 10.6654 7.5C10.6654 7.61065 10.7094 7.71676 10.7876 7.795C10.8659 7.87324 10.972 7.91719 11.0826 7.91719C11.1933 7.91719 11.2994 7.87324 11.3776 7.795L13.8776 5.295Z",
                fill: "#616161"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BookingIcon);


/***/ }),

/***/ 5172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var LocationIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "11",
        height: "10",
        viewBox: "0 0 11 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5.66595 7.5L6.16595 6.5V3.929C7.02645 3.7055 7.66596 2.929 7.66596 2C7.66596 0.897 6.76895 0 5.66595 0C4.56295 0 3.66595 0.897 3.66595 2C3.66595 2.929 4.30545 3.7055 5.16595 3.929V6.5L5.66595 7.5ZM4.66595 2C4.66595 1.4485 5.11445 1 5.66595 1C6.21745 1 6.66595 1.4485 6.66595 2C6.66595 2.5515 6.21745 3 5.66595 3C5.11445 3 4.66595 2.5515 4.66595 2Z",
                fill: "#616161"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M7.79946 4.2815L7.53295 5.2455C8.82845 5.6035 9.66595 6.292 9.66595 7C9.66595 7.946 8.02345 9 5.66595 9C3.30845 9 1.66595 7.946 1.66595 7C1.66595 6.292 2.50345 5.6035 3.79945 5.245L3.53295 4.281C1.76445 4.77 0.665955 5.8115 0.665955 7C0.665955 8.682 2.86245 10 5.66595 10C8.46945 10 10.666 8.682 10.666 7C10.666 5.8115 9.56745 4.77 7.79946 4.2815Z",
                fill: "#616161"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LocationIcon);


/***/ }),

/***/ 6933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var PhoneIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "9",
        height: "12",
        viewBox: "0 0 9 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7.7322 11.0604C2.99155 10.3164 -0.0292545 6.1065 0.719913 1.4088C0.768574 1.10157 1.05707 0.890985 1.36375 0.939558L2.83046 1.17186C3.10547 1.21542 3.30734 1.45469 3.30478 1.73335C3.2981 2.4015 3.38734 3.06715 3.56977 3.70995L3.60746 3.84235C3.63275 3.93143 3.62616 4.02655 3.58883 4.1113C3.55149 4.19605 3.48575 4.26511 3.40294 4.30657C2.8971 4.55905 2.62036 5.18439 2.89366 5.74935C3.23774 6.46068 3.70573 7.10505 4.27574 7.65229C4.72923 8.08633 5.40949 8.01638 5.80528 7.61378C5.87028 7.54761 5.95637 7.50624 6.04865 7.49683C6.14093 7.48742 6.2336 7.51057 6.31062 7.56226L6.42443 7.63838C6.97934 8.01102 7.58482 8.30169 8.22231 8.50176C8.48812 8.58543 8.6533 8.85136 8.60966 9.12692L8.37744 10.5931C8.36588 10.6661 8.34004 10.7361 8.3014 10.7991C8.26276 10.8621 8.21209 10.9169 8.15227 10.9603C8.09244 11.0037 8.02465 11.0349 7.95277 11.0521C7.88088 11.0693 7.80631 11.0722 7.73331 11.0606L7.7322 11.0604Z",
            fill: "#616161"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PhoneIcon);


/***/ }),

/***/ 4233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_common_mainButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7749);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4959);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var ScrollWidget = function(param) {
    var _distance = param.distance, distance = _distance === void 0 ?  true ? window.innerHeight * 0.8 : 0 : _distance, _behavior = param.behavior, behavior = _behavior === void 0 ? "smooth" : _behavior;
    var scrollDown = function() {
        if (true) window.scrollTo({
            top: distance !== null && distance !== void 0 ? distance : window.innerHeight * 0.8,
            behavior: behavior
        });
    };
    // if the user scrolled down, don't show the scroll widget
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), showScrollWidget = ref[0], setShowScrollWidget = ref[1];
    var handleScroll = function() {
        if (window.scrollY > 0) {
            setShowScrollWidget(false);
        } else {
            setShowScrollWidget(true);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_mainButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: [
            (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().button),
            showScrollWidget ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().show) : (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().hide), 
        ].join(" "),
        onClick: scrollDown,
        children: "↓ Scroll ↓"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ScrollWidget);


/***/ }),

/***/ 6321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages_membership; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/contexts/providers/language.tsx
var providers_language = __webpack_require__(9327);
// EXTERNAL MODULE: ./src/localization/en.ts
var en = __webpack_require__(1257);
// EXTERNAL MODULE: ./src/localization/fr.ts
var fr = __webpack_require__(1916);
;// CONCATENATED MODULE: ./src/components/membership/about/index.tsx




var MembershipAbout = function() {
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var membershipTexts = language === "En" ? en/* default.membershipPage.about */.Z.membershipPage.about : fr/* default.membershipPage.about */.Z.membershipPage.about;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "p-1 bbg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "description",
                children: membershipTexts
            })
        })
    });
};
/* harmony default export */ var about = (MembershipAbout);

// EXTERNAL MODULE: ./src/components/ui/scrollWidget/index.tsx
var scrollWidget = __webpack_require__(4233);
// EXTERNAL MODULE: ./src/components/membership/scrollWidget/index.module.scss
var index_module = __webpack_require__(2560);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/components/membership/scrollWidget/index.tsx



var MembershipScrollWidget = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).membershipScrollWidget,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(scrollWidget/* default */.Z, {})
    });
};
/* harmony default export */ var membership_scrollWidget = (MembershipScrollWidget);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/ui/modal/index.tsx
var modal = __webpack_require__(5136);
// EXTERNAL MODULE: ./src/components/common/img/index.tsx
var img = __webpack_require__(561);
// EXTERNAL MODULE: ./src/components/common/mainButton/index.tsx + 1 modules
var mainButton = __webpack_require__(7749);
// EXTERNAL MODULE: ./src/components/icons/asperand.icon.tsx
var asperand_icon = __webpack_require__(9885);
// EXTERNAL MODULE: ./src/components/icons/booking.icon.tsx
var booking_icon = __webpack_require__(4046);
// EXTERNAL MODULE: ./src/components/icons/location.icon.tsx
var location_icon = __webpack_require__(5172);
// EXTERNAL MODULE: ./src/components/icons/phone.icon.tsx
var phone_icon = __webpack_require__(6933);
// EXTERNAL MODULE: ./src/components/membership/partners/index.module.scss
var partners_index_module = __webpack_require__(8400);
var partners_index_module_default = /*#__PURE__*/__webpack_require__.n(partners_index_module);
;// CONCATENATED MODULE: ./src/components/membership/partners/index.tsx








var MembershipPartners = function(param) {
    var partnerships = param.partnerships, handleCloseModal = param.handleCloseModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: [
            (partners_index_module_default()).membershipPartners,
            "no-scrollbar"
        ].join(" "),
        onClick: handleCloseModal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (partners_index_module_default()).backgroundFilter
            }),
            partnerships.map(function(partnership) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(img/* default */.Z, {
                            src: partnership.picturePath,
                            lazyLoad: false,
                            alt: partnership.name,
                            containerProps: {
                                className: (partners_index_module_default()).partner
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (partners_index_module_default()).contactInformationContainer,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                                        href: partnership.websiteUrl,
                                        uiOnly: true,
                                        className: (partners_index_module_default()).name,
                                        children: partnership.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("address", {
                                        className: (partners_index_module_default()).contactInformation,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "tel:".concat(partnership.phoneNumber),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(phone_icon/* default */.Z, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "mailto:".concat(partnership.email),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asperand_icon/* default */.Z, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://maps.google.com/?q=".concat(partnership.location),
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                referrerPolicy: "no-referrer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(location_icon/* default */.Z, {})
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "mailto:".concat(partnership.email),
                                                className: (partners_index_module_default()).external,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: [
                                                    "Contact ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(asperand_icon/* default */.Z, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: partnership.websiteUrl,
                                                className: (partners_index_module_default()).external,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: [
                                                    "Discover ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(booking_icon/* default */.Z, {})
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (partners_index_module_default()).description,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: (partners_index_module_default()).location,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Location"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: partnership.location
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: partnership.descriptionEn
                                })
                            ]
                        })
                    ]
                }, partnership.id);
            })
        ]
    });
};
/* harmony default export */ var partners = (MembershipPartners);

// EXTERNAL MODULE: ./src/components/membership/selection/index.module.scss
var selection_index_module = __webpack_require__(6355);
var selection_index_module_default = /*#__PURE__*/__webpack_require__.n(selection_index_module);
;// CONCATENATED MODULE: ./src/utils/constants/user.ts
var subscriptionTypeToName = {
    MEMBER: "Member",
    MEMBER_PLUS: "Member Plus",
    REDUCED_MEMBER: "Reduced Member",
    REDUCED_SPECIAL: "Reduced Special",
    SPECIAL: "Special"
};

// EXTERNAL MODULE: ./src/components/membership/selection/membership/index.module.scss
var membership_index_module = __webpack_require__(6647);
var membership_index_module_default = /*#__PURE__*/__webpack_require__.n(membership_index_module);
;// CONCATENATED MODULE: ./src/components/membership/selection/membership/index.tsx







var SelectionMembership = function(param) {
    var type = param.type, perks = param.perks;
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var membershipTexts = language === "En" ? en/* default.membershipPage */.Z.membershipPage : fr/* default.membershipPage */.Z.membershipPage;
    var membersNotice = language === "En" ? en/* default.membershipPage.membersNotice */.Z.membershipPage.membersNotice : fr/* default.membershipPage.membersNotice */.Z.membershipPage.membersNotice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (membership_index_module_default()).selectionMembership,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: subscriptionTypeToName[type]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                children: [
                    ">",
                    " ",
                    membersNotice
                ]
            }),
            perks.map(function(param, i) {
                var title = param.title, description = param.description;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (membership_index_module_default()).perk,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                            dangerouslySetInnerHTML: {
                                __html: "* ".concat(title)
                            }
                        }),
                        description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (membership_index_module_default()).perkDescription,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                dangerouslySetInnerHTML: {
                                    __html: "(".concat(description, ")")
                                }
                            })
                        })
                    ]
                }, "".concat(type, "-perk-").concat(i));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (membership_index_module_default()).priceContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: (membership_index_module_default()).priceTag,
                        children: membershipTexts.fullPrice
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: (membership_index_module_default()).priceTag,
                        children: membershipTexts.reducedPrice
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (membership_index_module_default()).center,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mainButton/* default */.Z, {
                    theme: "white",
                    href: "/apply",
                    className: (membership_index_module_default()).applicationButton,
                    children: "→ ".concat(membershipTexts.buttonText)
                })
            })
        ]
    });
};
/* harmony default export */ var membership = (SelectionMembership);

;// CONCATENATED MODULE: ./src/components/membership/selection/index.tsx









var MembershipSelection = function(param) {
    var partnerships = param.partnerships;
    var ref = (0,react.useState)(false), modalOpen = ref[0], setModalOpen = ref[1];
    var language = (0,providers_language/* useLanguage */.ZK)().language;
    var handleCloseModal = function() {
        setModalOpen(false);
    };
    var perks = language === "En" ? en/* default.membershipPage.memberPerks */.Z.membershipPage.memberPerks : fr/* default.membershipPage.memberPerks */.Z.membershipPage.memberPerks;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (selection_index_module_default()).membershipSelection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (selection_index_module_default()).membershipsContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(membership, {
                        type: "MEMBER",
                        perks: perks
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal/* default */.Z, {
                open: modalOpen,
                showAnimation: "expand",
                onClose: handleCloseModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partners, {
                    handleCloseModal: handleCloseModal,
                    partnerships: partnerships
                })
            })
        ]
    });
};
/* harmony default export */ var selection = (MembershipSelection);

// EXTERNAL MODULE: ./src/components/SEO/index.tsx
var SEO = __webpack_require__(7353);
;// CONCATENATED MODULE: ./src/pages/membership/index.tsx





var MembershipPage = function(param) {
    var partnerships = param.partnerships;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "Silencio - Adh\xe9sion",
                description: "\xcatre membre, c’est soutenir la cr\xe9ation contemporaine internationale. Rejoignez une communaut\xe9 d’artistes, de cr\xe9atifs et d’entrepreneurs du monde entier.",
                nofollow: false,
                noindex: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(membership_scrollWidget, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(about, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(selection, {
                partnerships: partnerships
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages_membership = (MembershipPage);


/***/ }),

/***/ 8400:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"membershipPartners":"partners_membershipPartners__w7lFz","backgroundFilter":"partners_backgroundFilter__1jsrg","partner":"partners_partner__zbR6w","contactInformationContainer":"partners_contactInformationContainer__ymQ_P","contactInformation":"partners_contactInformation__1S79S","external":"partners_external__98AFx","description":"partners_description__kOe5A","location":"partners_location__vqRRS"};

/***/ }),

/***/ 2560:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"membershipScrollWidget":"scrollWidget_membershipScrollWidget__CPwgZ"};

/***/ }),

/***/ 6355:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"membershipSelection":"selection_membershipSelection__GaenB","membershipsContainer":"selection_membershipsContainer__lBQcu"};

/***/ }),

/***/ 6647:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"selectionMembership":"membership_selectionMembership__GvO_h","perk":"membership_perk___ObIW","perkDescription":"membership_perkDescription__iaIzF","priceContainer":"membership_priceContainer__CPmsP","priceTag":"membership_priceTag__QJ8LW","applicationButton":"membership_applicationButton__PRsRh","center":"membership_center__b0juI"};

/***/ }),

/***/ 4959:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"scrollWidget_button__dFmMO","show":"scrollWidget_show__thqR6","hide":"scrollWidget_hide__Xu5X1"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [962,679,774,888,179], function() { return __webpack_exec__(28); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);